import {
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
  inject,
} from '@angular/core';
import { Image, ImageModule } from 'primeng/image';
import { IconButtonComponent } from './icon-button.component';
@Component({
  selector: 'app-preview-button',
  imports: [ImageModule, IconButtonComponent],
  template: `
    <app-icon-button
      icon="fa-light fa-file"
      tooltip="Preview"
      (click)="previewClick()"
    />

    @if (previewClicked) {
      <p-image
        [preview]="true"
        [src]="src"
        [alt]="alt"
        [width]="width"
        [height]="height"
        (onShow)="onPreviewShow()"
        #image
      >
        <ng-template #image> </ng-template>
      </p-image>
    }
  `,
  styles: ``,
})
export class PreviewButtonComponent {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('image')
  image: Image;

  @Input()
  src: string;

  @Input()
  alt: string;

  @Input()
  width: string;

  @Input()
  height: string;

  protected previewClicked = false;

  protected previewClick() {
    this.previewClicked = true;
    setTimeout(() => {
      const img = document.querySelector('[data-pc-section="original"]');
      if (img) {
        img.setAttribute('alt', this.alt);
      }
    });
    this.cdr.detectChanges();
    (this.image.previewButton.nativeElement as any).click();
  }

  protected onPreviewShow(): void {
    document
      .querySelector('.p-image-mask[role="dialog"]')
      ?.setAttribute('aria-label', this.alt || 'Report preview');
  }
}
